import IwIntlProvider from './iwIntlProvider/IwIntlProvider';
import { IwLogger } from './iwLogger/IwLogger';
import IwProvider from './iwProvider/IwProvider';
import { IwQueryClientProvider } from './iwQueryClient/IwQueryClientProvider';
import IwRouter from './iwRouter';
import IwSiteContext from './iwSiteContext/IwSiteContext';
import MyAccount from './myAccount/MyAccount';
import { NavVisibilityProvider } from './myAccount/navigation/NavVisibilityContext';

const App = () => {
    return (
        <IwQueryClientProvider>
            <IwLogger>
                <IwProvider>
                    <IwSiteContext>
                        <IwIntlProvider>
                            <IwRouter disableFirstRouterChange={true}>
                                <NavVisibilityProvider>
                                    <MyAccount />
                                </NavVisibilityProvider>
                            </IwRouter>
                        </IwIntlProvider>
                    </IwSiteContext>
                </IwProvider>
            </IwLogger>
        </IwQueryClientProvider>
    );
};

// eslint-disable-next-line import/no-default-export
export default App;
